import React, { useRef, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import pb from '../../lib/pocketbase';
import './Navbar.css';

const Navbar = ({
    user,
    showUserMenu,
    setShowUserMenu,
    setShowAuthModal,
    handleLogout,
    currentPage,
    setCurrentPage,
    navOpen,
    setNavOpen,
    toggleTheme,
    theme,
    showTour,
    tourStep,
    agencySettings
}) => {
    const userMenuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
                setShowUserMenu(false);
            }
        };

        if (showUserMenu) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showUserMenu, setShowUserMenu]);
    return (
        <div className="sticky-navbar-container">
            <header className="app-header-bar">
                <div className="app-header-content">
                    <Link to="/" className="navbar-brand">
                        {agencySettings ? (
                            <img 
                                src={theme === 'light' 
                                    ? (agencySettings.logo_light ? pb.files.getUrl(agencySettings, agencySettings.logo_light) : '/logo.png')
                                    : (agencySettings.logo_dark ? pb.files.getUrl(agencySettings, agencySettings.logo_dark) : '/logo.png')
                                } 
                                alt={`${agencySettings.company_name || 'L\'Univers Diag'} Logo`} 
                                className="navbar-logo" 
                            />
                        ) : (
                            <img src="/logo.png" alt="L'Univers Diag Logo" className="navbar-logo" />
                        )}
                        <div className="navbar-brand-text">
                            <h1>{agencySettings?.company_name || "L'Univers Diag"}</h1>
                            <p className="subtitle">{agencySettings?.slogan || "Atelier de reprogrammation automobile à Toulouse"}</p>
                        </div>
                    </Link>
                    <div className="header-right">
                        <Link to="/booking" className="btn-appointment">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                <line x1="16" y1="2" x2="16" y2="6"></line>
                                <line x1="8" y1="2" x2="8" y2="6"></line>
                                <line x1="3" y1="10" x2="21" y2="10"></line>
                            </svg>
                            Prendre RDV
                        </Link>
                        {user ? (
                            <Link to="/account" className="btn-secondary-nav">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="12" cy="7" r="4"></circle>
                                </svg>
                                Mon compte
                            </Link>
                        ) : (
                            <button onClick={() => setShowAuthModal(true)} className="btn-secondary-nav">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
                                    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
                                    <polyline points="10 17 15 12 10 7"></polyline>
                                    <line x1="15" y1="12" x2="3" y2="12"></line>
                                </svg>
                                Se connecter
                            </button>
                        )}
                        <div className="user-menu-container" ref={userMenuRef}>
                            <button
                                type="button"
                                className="user-btn"
                                onClick={() => {
                                    if (user) {
                                        setShowUserMenu(!showUserMenu);
                                    } else {
                                        setShowAuthModal(true);
                                    }
                                }}
                                aria-label="Mon compte"
                            >
                                {user ? (
                                    <span className="user-initials">{user.name.charAt(0)}</span>
                                ) : (
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                        <circle cx="12" cy="7" r="4"></circle>
                                    </svg>
                                )}
                            </button>
                            {showUserMenu && user && (
                                <div className="user-dropdown">
                                    <div className="user-dropdown-header">
                                        <span className="user-name">{user.name}</span>
                                        <span className="user-role">{user.role === 'admin' ? 'Administrateur' : 'Client'}</span>
                                    </div>

                                    <Link to="/admin" className="user-dropdown-item" onClick={() => setShowUserMenu(false)}>
                                        Espace Admin
                                    </Link>
                                    <Link to="/account" className="user-dropdown-item" onClick={() => setShowUserMenu(false)}>
                                        Mon compte
                                    </Link>
                                    <button className="user-dropdown-item logout" onClick={handleLogout}>
                                        Se déconnecter
                                    </button>
                                </div>
                            )}
                        </div>
                        <button
                            type="button"
                            className={`theme-toggle ${showTour && tourStep === 3 && currentPage === 'accueil' ? 'tour-highlight' : ''
                                }`}
                            onClick={toggleTheme}
                            aria-label="Changer le thème clair / sombre"
                            id="tour-step-theme"
                        >
                            <span className="theme-icon" />
                        </button>
                        <div className="contact-short">
                            <p className="contact-phone">NOUS APPELER</p>
                            <p className="contact-phone-number">{agencySettings?.phone_public || "07 58 04 43 77"}</p>
                        </div>
                        <button
                            type="button"
                            className="nav-toggle"
                            onClick={() => setNavOpen((open) => !open)}
                            aria-label="Ouvrir le menu de navigation"
                        >
                            <span className="nav-toggle-bar" />
                            <span className="nav-toggle-bar" />
                            <span className="nav-toggle-bar" />
                        </button>
                    </div>
                </div>
            </header>

            {navOpen && <div className="nav-overlay" onClick={() => setNavOpen(false)} />}

            <nav className={`main-nav ${navOpen ? 'open' : ''}`}>
                <button
                    type="button"
                    className="nav-close-btn"
                    onClick={() => setNavOpen(false)}
                    aria-label="Fermer le menu"
                >
                    &times;
                </button>

                <div className="mobile-nav-top-actions">
                    <button
                        type="button"
                        className="mobile-theme-toggle"
                        onClick={toggleTheme}
                        aria-label="Changer le thème"
                    >
                        <span className="theme-icon" />
                        <span style={{ marginLeft: '12px', fontSize: '0.9rem', fontWeight: '500' }}>
                            Sombre / Clair
                        </span>
                    </button>
                </div>

                <ul className="nav-list">
                    <li className="nav-item">
                        <NavLink
                            to="/"
                            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                            onClick={() => setNavOpen(false)}
                        >
                            Accueil
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            to="/cles"
                            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                            onClick={() => setNavOpen(false)}
                        >
                            Reproduction de clés
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            to="/ethanol"
                            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                            onClick={() => setNavOpen(false)}
                        >
                            Reprogrammation éthanol
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            to="/diagnostic"
                            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                            onClick={() => setNavOpen(false)}
                        >
                            Diagnostic
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            to="/devis"
                            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                            onClick={() => setNavOpen(false)}
                        >
                            Devis
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink
                            to="/contact"
                            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                            onClick={() => setNavOpen(false)}
                        >
                            Contact
                        </NavLink>
                    </li>
                </ul>

                <div className="mobile-actions">
                    <Link to="/booking" className="mobile-btn-appointment" onClick={() => setNavOpen(false)}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                            <line x1="16" y1="2" x2="16" y2="6"></line>
                            <line x1="8" y1="2" x2="8" y2="6"></line>
                            <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        Prendre RDV
                    </Link>

                    {user ? (
                        <Link to="/account" className="mobile-btn-secondary" onClick={() => setNavOpen(false)}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                <circle cx="12" cy="7" r="4"></circle>
                            </svg>
                            Mon compte
                        </Link>
                    ) : (
                        <button
                            className="mobile-btn-secondary"
                            onClick={() => {
                                setNavOpen(false);
                                setShowAuthModal(true);
                            }}
                        >
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
                                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
                                <polyline points="10 17 15 12 10 7"></polyline>
                                <line x1="15" y1="12" x2="3" y2="12"></line>
                            </svg>
                            Se connecter
                        </button>
                    )}
                </div>
            </nav>
        </div>
    );
};

export default Navbar;
